module.exports = __webpack_public_path__ + "img/map_outfield-pavilion.af42d2d8.jpg";